import React, { useEffect } from 'react'
import { hydrate } from 'react-dom'
import App from './App'

import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import { loadableReady } from '@loadable/component'
import { CookiesProvider } from 'react-cookie'


let initialData
let windowData = window.__INITIAL_DATA__

if (windowData && windowData.data && !windowData.data.timeout) {
  initialData = windowData
}
const RemoveMaterialUiStyles = () => {
  useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side')
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles)
    }
  }, [])
  return true
}

loadableReady().then(() => {
  const app = (
    <CookiesProvider>
      <BrowserRouter>
        <RemoveMaterialUiStyles />
        <App initialData={initialData} />
      </BrowserRouter>
    </CookiesProvider>
  )
  hydrate(app, document.getElementById('root'))
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()

if (module.hot) {
  module.hot.accept()
}
